/**
 * Transfer ActionTypes
 */
export enum Actions {
  UPDATE_TRANSFER_INPUT = "UPDATE_TRANSFER_INPUT",
  UPDATE_RADIO_GROUP = "UPDATE_RADIO_GROUP",
  UPDATE_SELECT_VALUE = "UPDATE_SELECT_VALUE",
  SET_TRANSFER_INPUT_DIRTY = "SET_TRANSFER_INPUT_DIRTY",
  SWITCH_TRANSFER_VALIDITY = "SWITCH_TRANSFER_VALIDITY",
  SET_TRANSFER_TOKEN = "SET_TRANSFER_TOKEN",
  SET_BANK_LIST_ITEMS = "SET_BANK_LIST_ITEMS",
  DISABLE_TRANSFER_FORM = "DISABLE_TRANSFER_FORM",
  SET_TRANSFER_CHILE = "SET_TRANSFER_CHILE",
  SET_TRANSFER_MEXICO = "SET_TRANSFER_MEXICO",
  SET_TRANSFER_COLOMBIA = "SET_TRANSFER_COLOMBIA",
  SET_TRANSFER_ECUADOR = "SET_TRANSFER_ECUADOR",
  SET_TRANSFER_PERU = "SET_TRANSFER_PERU",
}



// WEBPACK FOOTER //
// ./src/containers/Transfer/store/Actions.ts